import React from 'react';
import TooltipContext from './TooltipContext';
import useFloatingTooltip from './useFloatingTooltip';
import {TooltipSettings} from './model';

export default function TooltipProvider({children, ...options}: React.PropsWithChildren<TooltipSettings>) {
    const tooltip = useFloatingTooltip(options);
    return <TooltipContext.Provider value={tooltip}>{children}</TooltipContext.Provider>;
}
